import axios from "axios";
import { ElMessage } from "element-plus";
import store from '@/store'
import { getToken } from '@/utils/auth'
import router from '@/router'
import { generateAesKey, rsaEncrypt, aesEncrypt, aesDecrypt } from '@/utils/crypto'

// 防止401/403重复处理的标志
let isRefreshing = false;

const service = axios.create({
  baseURL: "/api",
  timeout: 5000,
});

service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers["Authorization"] = "Bearer " + getToken();
    }
    if (store.getters.tenantInfo) {
      config.headers["tenantId"] = store.getters.tenantInfo.tenantId;
    }

    // 加密处理：加密功能已启用时，所有请求都加密
    const cryptoEnabled = store.getters.cryptoEnabled
    const publicKey = store.getters.rsaPublicKey
    if (cryptoEnabled && publicKey) {
      // 生成AES密钥，绑定到当前请求config上（避免并发请求时密钥被覆盖）
      const aesKey = generateAesKey()
      config._aesKey = aesKey
      // RSA加密AES密钥
      const encryptedKey = rsaEncrypt(aesKey, publicKey)
      // 设置加密头
      config.headers["Encrypted-Key"] = encryptedKey
      // AES加密请求体（POST/PUT/PATCH）
      if (config.data) {
        const dataStr = typeof config.data === 'string' ? config.data : JSON.stringify(config.data)
        config.data = aesEncrypt(dataStr, aesKey)
        config.headers["Content-Type"] = "application/json;charset=UTF-8"
        config.transformRequest = [(data) => data]
      }
      // AES加密查询参数（GET/DELETE）
      if (config.params) {
        const paramsStr = JSON.stringify(config.params)
        config.params = { enc: aesEncrypt(paramsStr, aesKey) }
      }
    }

    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    // 解密处理：如果响应头标记了加密
    const isEncrypted = response.headers['x-crypto']
    if (isEncrypted === '1') {
      const aesKey = response.config._aesKey
      if (aesKey && typeof response.data === 'string') {
        try {
          const decrypted = aesDecrypt(response.data, aesKey)
          response.data = JSON.parse(decrypted)
        } catch (e) {
          console.error('响应解密失败', e)
        }
      }
    }

    const res = response.data;

    if (res.code !== 200) {
      if (res.code === 401 || res.code === 403) {
        // 防止重复处理
        if (isRefreshing) {
          return Promise.reject(new Error("未授权"));
        }
        isRefreshing = true;

        router.push("/403");
        isRefreshing = false;

        return Promise.reject(new Error("未授权"));
      }
      ElMessage({
        message: res.msg || "Error",
        type: "error",
        duration: 3000,
      });
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    console.log("err" + error);
    ElMessage({
      message: error.message,
      type: "error",
      duration: 3000,
    });
    return Promise.reject(error);
  },
);

export default service;
